import { FaExclamationTriangle } from "react-icons/fa";

export default function HTSCard({
  primaryHts,
  alternativeHts = [],
  compact = false,
}) {

  // 🔍 DEBUG — remove later
  console.log("HTSCard rendered:", primaryHts);

  // ⛔️ Hard stop if no HTS
  if (!primaryHts || !primaryHts.code) {
    console.warn("HTSCard: primaryHts missing or invalid", primaryHts);
    return null;
  }

  const formatHTSCode = (code = "") => {
    const clean = String(code).replace(/\D/g, "");
    if (clean.length === 10) {
      return `${clean.slice(0, 4)}.${clean.slice(4, 6)}.${clean.slice(6)}`;
    }
    return code;
  };

  /* =========================
     COMPACT MODE
  ========================= */
  if (compact) {
    return (
      <div className="flex items-center gap-3">
        <span className="font-mono text-lg font-bold text-orange-600">
          {formatHTSCode(primaryHts.code)}
        </span>

        {primaryHts.generalDutyRatePercent != null && (
          <span className="text-sm text-gray-500">
            {primaryHts.generalDutyRatePercent}% duty
          </span>
        )}

        {primaryHts.sec301China?.applies && (
          <span className="px-2 py-0.5 text-xs bg-yellow-100 text-yellow-800 rounded">
            301
          </span>
        )}
      </div>
    );
  }

  /* =========================
     FULL CARD
  ========================= */
  return (
    <div className="space-y-4">

      {/* PRIMARY HTS */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 p-6 rounded-xl text-white">
        <div className="text-sm opacity-80 mb-1">Primary HTS Code</div>

        <div className="font-mono text-3xl font-bold text-orange-300">
          {formatHTSCode(primaryHts.code)}
        </div>

        <div className="flex gap-6 mt-3 flex-wrap">
          {primaryHts.generalDutyRatePercent != null && (
            <div>
              <span className="text-sm opacity-80">General Duty:</span>
              <span className="ml-2 font-semibold">
                {primaryHts.generalDutyRatePercent}%
              </span>
            </div>
          )}

          {primaryHts.confidence != null && (
            <div>
              <span className="text-sm opacity-80">Confidence:</span>
              <span className="ml-2 font-semibold">
                {primaryHts.confidence}%
              </span>
            </div>
          )}
        </div>
      </div>

      {/* SECTION 301 */}
      {primaryHts.sec301China?.applies && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex gap-3">
          <FaExclamationTriangle className="w-5 h-5 text-yellow-600 mt-0.5" />
          <div>
            <div className="font-medium text-yellow-800">
              Section 301 (China) Applies
            </div>
            <div className="text-sm text-yellow-700">
              Additional {primaryHts.sec301China.ratePercent ?? 0}% tariff
              {primaryHts.sec301China.list &&
                ` (${primaryHts.sec301China.list})`}
            </div>
          </div>
        </div>
      )}

      {/* RATIONALE */}
      {primaryHts.rationale && (
        <div className="bg-gray-100 rounded-lg p-4">
          <div className="text-sm font-medium text-gray-700 mb-1">
            Classification Rationale
          </div>
          <p className="text-sm text-gray-600">{primaryHts.rationale}</p>
        </div>
      )}

      {/* ALTERNATIVES */}
      {Array.isArray(alternativeHts) && alternativeHts.length > 0 && (
        <div>
          <div className="text-sm font-medium text-gray-700 mb-2">
            Alternative Classifications ({alternativeHts.length})
          </div>

          <div className="space-y-2">
            {alternativeHts.map((alt, idx) => (
              <div
                key={idx}
                className="flex justify-between items-center p-3 bg-white border rounded-lg"
              >
                <div className="flex gap-3">
                  <span className="font-mono font-medium">
                    {formatHTSCode(alt.code)}
                  </span>
                  {alt.generalDutyRatePercent != null && (
                    <span className="text-sm text-gray-500">
                      {alt.generalDutyRatePercent}% duty
                    </span>
                  )}
                </div>

                {alt.confidence != null && (
                  <span className="text-sm text-gray-500">
                    {alt.confidence}% confidence
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}

